import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { AspectRatio, RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { CommonModule } from '@angular/common';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { InnerSection, Section, SectionAttributes } from '../../../app/types/section';
import { SrcSetImageAttributes, SrcSetImageEditorIds, IMAGE_COMPONENT_NAME, ImageLinkAttributes, ImageLinkEditorIds } from '../../../app/types/image';
import { CaptionAttributes, CaptionEditorIds } from '../../../app/types/figure';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { iconArrowsRight } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';


export type FigureImageSection = InnerSection<
  SrcSetImageAttributes & Partial<CaptionAttributes> & Partial<ImageLinkAttributes>,
  SrcSetImageEditorIds | CaptionEditorIds | ImageLinkEditorIds,
  typeof IMAGE_COMPONENT_NAME
>;

type ImageCollectionSection = Section<
  {
    numColumns: 12 | 8 | 4;
    headline: string;
    mediums: FigureImageSection[];
  } & SectionAttributes,
  [
    'headline',
    'mediums',
  ],
  'image-collection'
>;

@Component({
    selector: 'section[app-image-collection]',
    styleUrls: ['./image-collection.component.scss'],
    templateUrl: './image-collection.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule, EditorIdDirective,
        OgImageDirective,
        CardComponent,
        LineClampComponent,
        PictureComponent,
        RouterOrExternalLinkDirective,
        IconComponent,
        FsButtonComponent,
    ],
})
export class ImageCollectionComponent extends SectionComponent<ImageCollectionSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected iconLink = iconArrowsRight;

}
